export const environment = {
  production: true,
  loginUrl: '/registrato/login/',
  googleTagManagerCode: 'GTM-P6R3G33',
};
